export function asNonNull<T>(value: T | null, message: string): T {
  return value !== null ? value : throwError(message);
}

export function throwError(message: string): never {
  throw new Error(message);
}
